export const version = "bignumber/5.1.1";
//# sourceMappingURL=_version.js.map